<div class="content-section">
  <h5 class="title dark">{{ 'nav.myLocker' | translate }}</h5>

  <ng-container>
    <mat-tab-group
      (selectedTabChange)="tabChanged($event)"
      [selectedIndex]="selectedTabIndex"
      mat-stretch-tabs="false"
      mat-align-tabs="start">
      <mat-tab label="{{ 'locker.live' | translate }}">
        <ng-template matTabContent>
          <div
            *ngIf="
              loadingInitialContent || loadingNextContent || bids.length;
              then bidsSection;
              else noBidsSection
            "></div>
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'locker.purchased' | translate }}">
        <ng-template matTabContent>
          <div
            *ngIf="
              loadingInitialContent || loadingNextContent || bids.length;
              then bidsSection;
              else noBidsSection
            "></div>
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'locker.lost' | translate }}">
        <ng-template matTabContent>
          <div
            *ngIf="
              loadingInitialContent || loadingNextContent || bids.length;
              then bidsSection;
              else noBidsSection
            "></div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <ng-template #bidsSection>
      <div
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50"
        [fromRoot]="true"
        (scrolled)="loadMore()">
        <card-locker
          *ngFor="let bid of bids"
          [id]="bid.auctionItemId"
          [userBidId]="bid.id"
          [purchaseCount]="bid.purchaseCount"
          [fulfillmentOption]="bid.fulfillmentOption"
          [customMessage]="bid.customMessage">
        </card-locker>
      </div>
      <p *ngIf="loadingInitialContent || loadingNextContent">{{ 'locker.loading' | translate }}</p>
    </ng-template>

    <ng-template #noBidsSection>
      <p>{{ 'locker.empty1' | translate }}</p>
      <p>{{ 'locker.empty2' | translate }}</p>
    </ng-template>
  </ng-container>
</div>
